import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import style from "./Sidebar.module.css";

interface Props {
  label: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
  basePath: string;
  children: React.ReactNode;
}

export function SidebarCollapsible({ label, icon: Icon, basePath, children }: Props) {
  const location = useLocation();
  const isActive = location.pathname.startsWith(basePath);
  const [open, setOpen] = useState(isActive);

  return (
    <>
      <button
        type="button"
        className={[
          style.collapsibleToggle,
          isActive ? style.collapsibleToggleActive : "",
        ].join(" ")}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Icon className={style.sidebarItemIcon} />
        <span className={style.sidebarLabel}>{label}</span>
        <ExpandMoreIcon
          className={[
            style.collapsibleChevron,
            open ? style.collapsibleChevronOpen : "",
          ].join(" ")}
        />
      </button>
      <Collapse in={open}>{children}</Collapse>
    </>
  );
}
